<template>
    <div class="card-body table-card-body">
        <div class="search-block">
            <div class="btn-group">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-expanded="false" :disabled="selectedIntegrationProducts.length === 0">{{ $t('buttons.actions') }}</button>
                <div class="dropdown-menu dropdown-menu-left" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(123px, 38px, 0px);">
                    <button class="dropdown-item" @click="showUpdateModal()">{{ $t('buttons.edit') }}</button>
                    <button class="dropdown-item" @click="showCreateModal()">{{ $t('buttons.create') }}</button>
                    <button class="dropdown-item" @click="deleteSelectedSourceProduct()">{{ $t('buttons.delete') }}</button>
                </div>
            </div>
            <InputGroup style="width: 250px">
                <template #prepend>
                    <span class="input-group-text"><i class="icon-search4"></i></span>
                </template>
                <Input v-model="search" type="text" :placeholder="translate('labels.search')"/>
            </InputGroup>
            <div class="btn-group">
                <button type="button" class="btn bg-light legitRipple" @click="$refs.filterModal.show()">
                    <i class="icon-filter3"></i>
                    <span v-if="activeFiltersCount > 0"> ({{ activeFiltersCount }})</span>
                </button>
                <button type="button" class="btn btn-icon btn-danger legitRipple" v-if="activeFiltersCount > 0" @click="clearFilters">
                    <i class="icon-cross2"></i>
                </button>
            </div>
        </div>
        <InputGroup style="width: 200px;" class="float-right">
            <template #prepend>
                <span class="input-group-text">{{ $t('labels.show') }}:</span>
            </template>
            <Select v-model="limit" :options="options" optionKey="key" optionValue="key"/>
        </InputGroup>
    </div>
    <div class="table-responsive">
        <table class="table table-bordered table-fixed">
            <thead>
                <tr>
                    <th width="60px">
                        <AppCheckbox :model-value="integrationProducts.length !== 0 && selectedIntegrationProducts.length === integrationProducts.length" @update:model-value="val => updateSelectedIntegrationProductsAll(val)" />
                    </th>
                    <th width="100px">{{ $t('table.titles.internal_id') }}</th>
                    <th width="100px">{{ $t('table.titles.image') }}</th>
                    <th width="100px">{{ $t('table.titles.id') }}</th>
                    <th width="100px">{{ $t('table.titles.source_id') }}</th>
                    <th width="100px">{{ $t('table.titles.second_source_id') }}</th>
                    <th width="150px">{{ $t('table.titles.category') }}</th>
                    <th width="100px">{{ $t('table.titles.sku') }}</th>
                    <th width="300px">{{ $t(`table.titles.name`) + ` (${this.$t(`shortLang.uk`)})` }}</th>
                    <th width="300px">{{ $t(`table.titles.name`) + ` (${this.$t(`shortLang.ru`)})` }}</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(product, index) in integrationProducts">
                    <tr height="65px">
                        <td rowspan="2">
                            <AppCheckbox :model-value="selectedIntegrationProducts.includes(index)" @update:model-value="val => updateSelectedIntegrationProducts(index, val)" />
                        </td>
                        <td rowspan="2">
                            <AppNullableCell>
                                <template #default v-if="product.source.product_item_id">
                                    <router-link :to="{name: 'EditProductPage', params: { productUuid: product.source.product_item_uuid }}">
                                        {{ product.source.product_item_id }}
                                    </router-link>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td>
                            <div class="d-flex align-items-center justify-content-center">
                                <ImageZoomComponent
                                    :url="product.source?.images?.[0] ?? PLACEHOLDER_IMAGE_URL"
                                    :alt="product.source?.sku"
                                    :default-width="50"
                                    :default-height="50"
                                />
                            </div>
                        </td>
                        <td>
                            <AppNullableCell>
                                <template #default v-if="product.source.id">
                                    <router-link :to="{ name: 'Product', params: { integrationUuid: integrationSource.uuid, integrationProductUuid: product.source.uuid } }">
                                        {{ product.source.id }}
                                    </router-link>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td :rowspan="compareIntegrationProductFields('source_id', product) ? '2' : '1'">
                            <AppNullableCell>
                                <template #default v-if="product.source.source_id">
                                    {{ product.source.source_id }}
                                </template>
                            </AppNullableCell>
                        </td>
                        <td :rowspan="compareIntegrationProductFields('second_source_id', product) ? '2' : '1'">
                            <AppNullableCell>
                                <template #default v-if="product.source.second_source_id">
                                    {{ product.source.second_source_id }}
                                </template>
                            </AppNullableCell>
                        </td>
                        <td :rowspan="compareIntegrationProductFields(`category_names.${integrationSource.language_aliases[0]}`, product) ? '2' : '1'">
                            <AppNullableCell>
                                <template #default v-if="product.source.category_names">
                                    <span class="long-string">{{ getTranslationByMainIntegrationLanguageOrAvailable(integrationSource, 'category_names', product.source) }}</span>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td :rowspan="compareIntegrationProductFields('sku', product) ? '2' : '1'">
                            <AppNullableCell>
                                <template #default v-if="product.source.sku">
                                    <span class="long-string">{{ product.source.sku }}</span>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td :rowspan="compareIntegrationProductFields('names.uk', product) ? '2' : '1'">
                            <AppNullableCell>
                                <template #default v-if="product.source.names.uk">
                                    <span class="long-string">{{ product.source.names.uk }}</span>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td :rowspan="compareIntegrationProductFields('names.ru', product) ? '2' : '1'">
                            <AppNullableCell>
                                <template #default v-if="product.source.names.ru">
                                    <span class="long-string">{{ product.source.names.ru }}</span>
                                </template>
                            </AppNullableCell>
                        </td>
                    </tr>
                    <tr height="65px">
                        <td>
                            <AppNullableCell>
                                <template #default v-if="product.target">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <ImageZoomComponent
                                            :url="product.target?.image_url ?? PLACEHOLDER_IMAGE_URL"
                                            :alt="product.target?.sku"
                                            :default-width="50"
                                            :default-height="50"
                                        />
                                    </div>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td>
                            <AppNullableCell>
                                <template #default v-if="product.target?.id">
                                    <router-link :to="{ name: 'Product', params: { integrationUuid: integrationTarget.uuid, integrationProductUuid: product.target.uuid } }">
                                        {{ product.target.id }}
                                    </router-link>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td v-if="!compareIntegrationProductFields('source_id', product)">
                            <AppNullableCell>
                                <template #default v-if="product.target?.source_id">
                                    {{ product.target.source_id }}
                                </template>
                            </AppNullableCell>
                        </td>
                        <td v-if="!compareIntegrationProductFields('second_source_id', product)">
                            <AppNullableCell>
                                <template #default v-if="product.target?.second_source_id">
                                    {{ product.target.second_source_id }}
                                </template>
                            </AppNullableCell>
                        </td>
                        <td v-if="!compareIntegrationProductFields(`category_names.${integrationTarget.language_aliases[0]}`, product)">
                            <AppNullableCell>
                                <template #default v-if="product.target?.category_names">
                                    <span class="long-string">{{ getTranslationByMainIntegrationLanguageOrAvailable(integrationTarget, 'category_names', product.target) }}</span>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td v-if="!compareIntegrationProductFields('sku', product)">
                            <AppNullableCell>
                                <template #default v-if="product.target?.sku">
                                    <span class="long-string">{{ product.target.sku }}</span>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td v-if="!compareIntegrationProductFields('names.uk', product)">
                            <AppNullableCell>
                                <template #default v-if="product.target?.names.uk">
                                    <span class="long-string">{{ product.target.names.uk }}</span>
                                </template>
                            </AppNullableCell>
                        </td>
                        <td v-if="!compareIntegrationProductFields('names.ru', product)">
                            <AppNullableCell>
                                <template #default v-if="product.target?.names.ru">
                                    <span class="long-string">{{ product.target.names.ru }}</span>
                                </template>
                            </AppNullableCell>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
    <div class="card-footer d-flex justify-content-between align-items-center">
        <span>{{ $t('labels.showing') }} {{ start }} - {{ end }} {{ $t('labels.of') }} {{ total }} {{ $t('labels.entries') }}</span>
        <ul class="pagination pagination-flat align-self-center">
            <li :class="['page-item', { 'disabled': page === 1 }]" class="paginate_button">
                <a class="page-link" @click="changePage(page - 1)">←</a>
            </li>
            <li v-for="pageNumber in pagesToRender" :key="pageNumber" :class="['page-item', { 'active': pageNumber === page }]" class="paginate_button">
                <a class="page-link" @click="changePage(pageNumber)">{{ pageNumber }}</a>
            </li>
            <li :class="['page-item', { 'disabled': page === pagesNumber }]" class="paginate_button">
                <a class="page-link" @click="changePage(page + 1)">→</a>
            </li>
        </ul>
    </div>
    <CompareIntegrationsFilterModal ref="filterModal" :integration-source-uuid="integrationSource.uuid" @apply-filters="handleFiltersApply"/>
    <CreateIntegrationProductsModal
        ref="createIntegrationProductsModal"
        :target-integration-uuid="integrationTarget.uuid"
        :target-integration-service="integrationTarget.service"
        :target-integration-name="integrationTarget.name"
        :integration-source-uuid="integrationSource.uuid"
        @update-table="fetchIntegrationProducts()"
    />
    <EditIntegrationProductsModal
        ref="editIntegrationProductsModal"
        :main-source-integration-language="integrationSource.language_aliases[0]"
        @update-table="fetchIntegrationProducts()"
    />
</template>

<script>
import AppNullableCell from '../../../components/tables/AppNullableCell.vue';
import Select from '../../../../components/new/form/select/Select.vue';
import InputGroup from '../../../../components/new/form/InputGroup.vue';
import Input from '../../../../components/new/form/Input.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import CompareIntegrationsFilterModal from './CompareIntegrationsFilterModal.vue';
import AppCheckbox from '../../../../components/new/form/checkbox/AppCheckbox.vue';
import CreateIntegrationProductsModal from './CreateIntegrationProductsModal.vue';
import EditIntegrationProductsModal from './EditIntegrationProductsModal.vue';
import ImageZoomComponent from '../../../../components/new/image/ImageZoomComponent.vue';
import { PLACEHOLDER_IMAGE_URL } from '../../../../constants';
import { httpClient } from '../../../../services/HttpClient';
import HttpSender from '../../../../services/Http/HttpSender';
import HttpRequest from '../../../../services/Http/HttpRequest';
import MessageNotificator from '../../../../services/MessageNotificator';

export default {
    name: "CompareIntegrationsTable",
    components: {
        AppNullableCell, Select, InputGroup, Input, AppButton, CompareIntegrationsFilterModal, AppCheckbox,
        CreateIntegrationProductsModal, EditIntegrationProductsModal, ImageZoomComponent
    },
    props: {
        integrationSource: {
            type: Object,
            required: true
        },
        integrationTarget: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            PLACEHOLDER_IMAGE_URL,
            options: [
                {key: 10, value: 10},
                {key: 25, value: 25},
                {key: 50, value: 50},
                {key: 100, value: 100},
            ],
            page: 1,
            limit: 10,
            search: '',
            total: 0,
            searchDebounceTimer: null,
            integrationProducts: [],
            filters: {},
            activeFiltersCount: 0,
            selectedIntegrationProducts: []
        };
    },
    methods: {
        deleteSelectedSourceProduct() {
            new MessageNotificator().confirm(this.$t('alerts.confirm_delete', {
                value: this.$t('labels.product')
            }), async () => {
                // The same source publication comes in several rows when the target channel has several publications of its product.
                const sourceProductUuids = new Set(this.selectedIntegrationProducts.map(index => this.integrationProducts[index].source.uuid));

                let requests = [...sourceProductUuids].map(uuid => new HttpRequest(
                    "DELETE",
                    `/integrations/products/${uuid}`
                ))

                await new HttpSender().sendRequestsInBatches(requests, () => {})

                this.selectedIntegrationProducts = [];
                this.fetchIntegrationProducts();
            })
        },
        changePage(newValue) {
            if (newValue > this.pagesNumber || newValue < 1 || newValue === this.page) {
                return;
            }
            this.page = newValue;
            this.fetchIntegrationProducts();
        },
        fetchIntegrationProducts() {
            this.selectedIntegrationProducts = [];
            httpClient.get(`/integrations/${this.integrationSource.uuid}/compare/${this.integrationTarget.uuid}/products`, {
                limit: this.limit,
                page: this.page,
                search: this.search,
                ...this.filters
            })
                .then(response => {
                    this.integrationProducts = response.data.data;
                    this.total = response.data.meta.total;
                    this.page = response.data.meta.page;
                });
        },
        getNestedValue(obj, path) {
            return path.split('.').reduce((o, p) => (o ? o[p] : null), obj);
        },
        compareIntegrationProductFields(field, product) {
            const sourceValue = this.getNestedValue(product.source, field);
            const targetValue = this.getNestedValue(product.target, field);

            if (!sourceValue && !targetValue) {
                return true;
            }

            return sourceValue !== targetValue ? false : true;
        },
        getTranslationByMainIntegrationLanguageOrAvailable(integration, field, product) {
            if (!product) {
                return null;
            }

            let mainLang = integration.language_aliases[0];
            let fieldTranslations = this.getNestedValue(product, field);

            return fieldTranslations?.[mainLang] || Object.values(fieldTranslations)[0];
        },
        translate(key) {
            return this.$t(key);
        },
        clearFilters() {
            this.$refs.filterModal.clear();
        },
        handleFiltersApply(newFilters, count = 0) {
            this.filters = newFilters;
            this.activeFiltersCount = count;
            this.page = 1;
            this.fetchIntegrationProducts();
        },
        updateSelectedIntegrationProducts(index, isSelected) {
            if (isSelected) {
                if (!this.selectedIntegrationProducts.includes(index)) {
                    this.selectedIntegrationProducts.push(index);
                }
            } else {
                this.selectedIntegrationProducts = this.selectedIntegrationProducts.filter(i => i !== index);
            }
        },
        updateSelectedIntegrationProductsAll(isSelected) {
            if (isSelected) {
                this.selectedIntegrationProducts = this.integrationProducts.map((_, index) => index);
            } else {
                this.selectedIntegrationProducts = [];
            }
        },
        showCreateModal() {
            const productsWithoutTarget = this.integrationProducts
                .filter((_, index) => this.selectedIntegrationProducts.includes(index))
                .filter(product => !product.target);
            const tableFilters = this.search ? { search: this.search, ...this.filters } : { ...this.filters };
            this.$refs.createIntegrationProductsModal.show(productsWithoutTarget, this.total, tableFilters);
        },
        showUpdateModal() {
            const productsWithTarget = this.integrationProducts
                .filter((_, index) => this.selectedIntegrationProducts.includes(index))
                .filter(product => product.target);
            this.$refs.editIntegrationProductsModal.show(productsWithTarget);
        }
    },
    computed: {
        pagesNumber() {
            if (this.total <= this.limit) {
                return 1;
            }
            return Math.ceil(this.total / this.limit);
        },
        pagesToRender() {
            const visible = 5;
            const middle = Math.floor(visible / 2);
            let start = this.page - middle;
            let end = start + visible - 1;

            if (start < 1) {
                start = 1;
                end = Math.min(visible, this.pagesNumber);
            } else if (end > this.pagesNumber) {
                end = this.pagesNumber;
                start = Math.max(1, end - visible + 1);
            }

            const pages = [];
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            
            return pages;
        },
        start() {
            if (this.page === 1) {
                return 1;
            }
            return ((this.page - 1) * this.limit) + 1;
        },
        end() {
            let end = (this.start + this.limit) - 1;
            return end > this.total ? this.total : end;
        }
    },
    watch: {
        search() {
            this.page = 1;

            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }

            this.searchDebounceTimer = setTimeout(() => {
                this.fetchIntegrationProducts();
                this.searchDebounceTimer = null;
            }, 500);
        },
        limit() {
            this.page = 1;
            this.fetchIntegrationProducts();
        },
    },
    beforeUnmount() {
        if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = null;
        }
    }
}
</script>

<style scoped>
.long-string {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.search-block {
    display: flex;
    gap: 10px;
}
.table-card-body {
    display: flex;
    justify-content: space-between;
}
.page-item:not(.disabled){
    cursor: pointer;
}
</style>
